export default {"src":"/_next/static/media/icon-default-avatar.86d6a0a1.svg","height":40,"width":40};